import {
  dealGasOrder
} from '@/cllib/sys_lib'

import {
  gasOrderGetData
} from '@/api/api'

import {
  tableSortDatas
} from '@/fm-table/lib/sort_list'

import {
  dataListFilter
} from '@/fm-table/lib/tools'

const state = {
  allOrder: [],
  showAllOrderData: [],
  allOrderLoading: false,
  chooseAdjustAllOrder: {},
  allOrderSearchParm: {},
  allOrderSortParm: {}
}

const getters = {
  allOrder: state => state.allOrder,
  allOrderSearchParm: state => state.allOrderSearchParm,
  allOrderSortParm: state => state.allOrderSortParm,
  showAllOrderData: state => state.showAllOrderData,
  allOrderLoading: state => state.allOrderLoading,
  chooseAdjustAllOrder: state => state.chooseAdjustAllOrder
}

const actions = {
  loadAllOrder ({ dispatch, getters }, parm) {
    dispatch('setAllOrderLoading', true)
    parm.groupId = getters.currentGroupId
    return gasOrderGetData(parm).then((data) => {
      dispatch('setAllOrder', dealGasOrder(data))
      dispatch('dealAllOrderList')
      dispatch('setAllOrderLoading', false)
    }).catch((e) => {
      dispatch('setAllOrderLoading', false)
    })
  },
  loadAllOrderToUpdate ({ dispatch, getters }, parm) {
    dispatch('setAllOrderLoading', true)
    parm.groupId = getters.currentGroupId
    return gasOrderGetData(parm).then((data) => {
      dispatch('setAllOrder', dealGasOrder(data))
      data.forEach((dataItem) => {
        let dataMap = {}
        for (let key in dataItem) {
          if (['emptyHour', 'notinVolume', 'overStockStatus', 'volume'].includes(key)) {
            dataMap[key] = dataItem[key]
          }
        }
        dispatch('updateShowGasOrderData', {id: dataItem.id, dataMap})
        dispatch('setAllOrderLoading', false)
      })
    }).catch((e) => {
      dispatch('setAllOrderLoading', false)
    })
  },
  updateGasOrderIsSend ({ dispatch, getters }, {isSend, id}) {
    if (!id) {
      return
    }
    let parm = {
      isSend: isSend ? 1 : 0,
      id: id
    }
    dispatch('gasOrderUpdateData', parm).then(() => {
      dispatch('updateGasOrderData', {id, dataMap: {isSend}})
      if (!isSend) {
        for (let key in getters.chooseOrders) {
          if (getters.chooseOrders[key] === id) {
            dispatch('setChooseOrderOne', {key, data: null})
          }
        }
      }
    })
  },
  updateGasOrderData ({ commit }, data) {
    commit('updateGasOrderData', data)
  },
  updateShowGasOrderData ({ commit }, data) {
    commit('updateShowGasOrderData', data)
  },
  dealAllOrderList ({ dispatch, getters }) {
    let data = getters.allOrder
    data = dataListFilter(data, getters.allOrderSearchParm.searchMap, getters.allOrderSearchParm.searchConfig)
    data = tableSortDatas(data, getters.allOrderSortParm.relationSort, getters.allOrderSortParm.sortMap, getters.allOrderSortParm.sortConfig, getters.allOrderSortParm.sortOrder)
    dispatch('setShowAllOrderData', data)
  },
  setShowAllOrderData ({ commit }, data) {
    commit('setShowAllOrderData', data)
  },
  setAllOrder ({ commit }, data) {
    commit('setAllOrder', data)
  },
  setAllOrderLoading ({ commit }, data) {
    commit('setAllOrderLoading', data)
  },
  setAllOrderSearchParm ({ commit, dispatch }, data) {
    commit('setAllOrderSearchParm', data)
    dispatch('dealAllOrderList')
  },
  setAllOrderSortParm ({ commit, dispatch }, data) {
    commit('setAllOrderSortParm', data)
    dispatch('dealAllOrderList')
  },
  setChooseAdjustAllOrderData ({ commit }, data) {
    commit('setChooseAdjustAllOrderData', data)
  },
  setChooseAdjustAllOrder ({ dispatch, getters }, data) {
    // 显示该站配送单 显示该站该油品pi图
    dispatch('setChooseAdjustAllOrderData', data)
    dispatch('setAdjustShowRouteOrderType', 'gas')
    let order = getters.chooseAdjustAllOrder
    dispatch('setChooseRouterOrderGas', order)
    if (getters.piGasTankId !== order.gasTankId) {
      dispatch('setAdjustPiGasTankId', order.gasTankId || null)
    }
  }
}

const mutations = {
  setAllOrder (state, data) {
    state.allOrder = data
  },
  setShowAllOrderData (state, data) {
    state.showAllOrderData = data
  },
  setAllOrderSortParm (state, data) {
    state.allOrderSortParm = data
  },
  setAllOrderSearchParm (state, data) {
    state.allOrderSearchParm = data
  },
  setAllOrderLoading (state, data) {
    state.allOrderLoading = data
  },
  updateGasOrderData (state, {id, dataMap}) {
    state.allOrder.forEach((item, index) => {
      if (item.id === id) {
        for (let key in dataMap) {
          item[key] = dataMap[key]
        }
        state.allOrder[index] = dealGasOrder([item])[0]
      }
    })
    state.showAllOrderData.forEach((item, index) => {
      if (item.id === id) {
        for (let key in dataMap) {
          item[key] = dataMap[key]
        }
        state.showAllOrderData[index] = dealGasOrder([item])[0]
      }
    })
  },
  updateShowGasOrderData (state, {id, dataMap}) {
    state.showAllOrderData.forEach((item, index) => {
      if (item.id === id) {
        for (let key in dataMap) {
          item[key] = dataMap[key]
        }
        state.showAllOrderData[index] = dealGasOrder([item])[0]
      }
    })
  },
  setChooseAdjustAllOrderData (state, data) {
    state.chooseAdjustAllOrder = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/adjust_order/all_order.js